import Icon from '../../components/Icon/Icon';
import { Dropdown } from 'primereact/dropdown';
import styles from './Overview.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from '../../store/reducers/uiSlice';
import CONSTANTS from '../../constants';
import { CSVLink } from 'react-csv';

const Overview = (props) => {
	const property = useSelector((state) => state.ui.selectedProperty);
	const filter = useSelector((state) => state.ui.filter);
	const dispatch = useDispatch();
	const rangeOptions = [
		'Last 24 hours',
		'Month to date',
		'Year to date',
		// 'All time',
	];

	const handleFilterChange = (e) => {
		dispatch(uiActions.changeFilter(e.value));
	};
	return (
		<div className={styles.container}>
			<div className={styles['overview__container']}>
				<Dropdown
					className={styles.dropdown}
					inputId="filter-dropdown"
					value={filter}
					onChange={(e) => {
						handleFilterChange(e);
					}}
					options={rangeOptions}
				/>
			</div>
			{props.aawise ? (
				<div className={styles['button__container']}>
					<span className="p-float-label">
						<Dropdown
							className={styles.dropdown}
							inputId="property-dropdown"
							value={property}
							onChange={(e) => {
								dispatch(uiActions.changeSelectedProperty(e.value));
							}}
							options={CONSTANTS.propertyOptions}
						/>
						{/* <label htmlFor="property-dropdown">Select a property</label> */}
					</span>
				</div>
			) : null}
			<CSVLink
				data={props.data}
				filename={`metrics_data`}
				className={styles['download_container']}
			>
				<Icon
					icon="download"
					className={styles['button-icon']}
					defaultColor="white"
				/>
				Export to CSV
			</CSVLink>
		</div>
	);
};

export default Overview;
